'use client'

import React from 'react'
import { Section } from '@/components/Section'
import { Callout } from '@/components/Callout'
import { TechStackBlock } from '@/payload-types'
import { Media } from '@/components/Media'

export const TechStackClient: React.FC<TechStackBlock> = (props) => {
  return (
    <Section bgClassName="bg-paper-4">
      <div className="flex flex-col xl:flex-row justify-between gap-[50px] xl:gap-x-[150px]">
        <div className="xl:max-w-[300px]">
          <Callout
            eyebrow={{ label: 'Sia Storage Network', color: 'punch' }}
            heading={props.heading}
            content={props.description}
            variant="dark"
          />
        </div>
        <div className="xl:flex-1">
          {typeof props.diagram === 'object' && (
            <Media
              resource={props.diagram}
              className="w-full select-none pointer-events-none"
              placeholder="empty"
            />
          )}
        </div>
      </div>
    </Section>
  )
}
